import { Skeleton } from "@mui/material";

export enum SKELETON_VARIANTS {
  TEXT = "text",
  ROUNDED = "rounded",
  RECTANGULAR = "rectangular",
  CIRCULAR = "circular",
}

export enum SKELETON_ANIMATIONS {
  PULSE = "pulse",
  WAVE = "wave",
}

export const MiSkeleton = ({
  variant = SKELETON_VARIANTS.TEXT,
  animation = SKELETON_ANIMATIONS.WAVE,
  height,
  width,
  className,
}: {
  variant?: SKELETON_VARIANTS;
  animation?: SKELETON_ANIMATIONS;
  height?: number | string;
  width?: number | string;
  className?: string;
}) => {
  return (
    <Skeleton
      variant={variant}
      animation={animation}
      height={height}
      width={width}
      classes={{ root: className }}
    />
  );
};
